export const listbookings = {
    // Check-in de una estancia vendida por horas: los campos mínimos
    rapido: "Rapide",
  text1: "Bienvenue !",
  text2: "Liste des check-ins, gérez ou envoyez un lien pour l'enregistrement de vos clients.",
  text3: "Liste des check-ins",
  text4: "Exporter",
  text5: "Nouveau check-in",
  text6: "Tous",
  text7: "En attente",
  text8: "Terminé",
  text9: "Aujourd'hui",
  text10: "Téléphone",
  text11: "Nom",
  text12: "Numéro de pièce d'identité",
  text13: "Pays",
  text14: "Check-in",
  text15: "Clés",
  text16: "Remises",
  text17: "En attente",
  text18: "Voir toutes les informations",
  text19: "Document signé",
  text20: "Tous",
  text21: "Une erreur s'est produite lors du processus de confirmation de la remise",
  text22: "Informations de check-in",
  text23: "Données recueillies lors du check-in du client",
  text24: "Prénom",
  text25: "Nom",
  text26: "Téléphone",
  text27: "Date d'hébergement",
  text28: "Type de document",
  text29: "Passeport",
  text30: "Document national d'identité",
  text31: "Numéro de document",
  text32: "Expiration du document",
  text33: "Nationalité",
  text34: "Date de naissance",
  text35: "Sexe",
  text36: "Femme",
  text37: "Homme",
  text38: "Écrivez ici votre ...",
  text39:
    "Bonjour [guest_name],\nBienvenue à l'HOTEL BARCELO MALAGA !\n\nMerci beaucoup de séjourner chez nous, nous vous informons que l'heure de check-out est fixée à 10h00.\n\nDe plus, nous vous communiquons les informations d'accès à notre réseau Wifi :\n\nRéseau : HOTEL-BARCELO\nMot de passe : xkamakj1a0\n\n\nNous espérons que votre séjour sera le plus agréable possible.\n\nNous sommes à votre disposition à la réception 24 heures sur 24.\n\nCordialement !",
  text40: "Le nom de votre hébergement est requis.",
  text41: "Les politiques de l'hébergement sont requises.",
  text42: "Un message de bienvenue doit être inclus.",
  text43: "Modifications enregistrées avec succès",
  text44: "Erreur de requête",
  text45: "Enregistré avec succès.",
  text46: "😃 Bonjour !! ",
  text47:
    " Vous avez terminé avec succès le processus de création de votre premier hébergement, vous pouvez désormais partager votre QR pour que les utilisateurs effectuent leur ",
  text48: "check-in",
  text49: "automatisé 👍",
  text50: "Vous pouvez modifier les champs saisis précédemment depuis le menu",
  text51: "Paramètres du modèle.",
  text52: "Télécharger",
  text53: "Continuer",
  text54: "Informations de check-in.",
  text55: "Données de check-in",
  text56: "Date de la demande :",
  text57: " à",
  text58: "Données recueillies lors du check-in du client",
  text59: "Nom",
  text60: "Nom de famille",
  text61: "Téléphone",
  text62: "Date d'hébergement",
  text63: "Type de document",
  text64: "Passeport",
  text65: "Document national d'identité",
  text66: "Numéro de document",
  text67: "Informations complémentaires",
  text68: "Expiration du document",
  text69: "Nationalité",
  text70: "Date de naissance",
  text71: "Sexe",
  text72: "Femme",
  text73: "Homme",
  text74: "Fermer",
  text75: "Nouveau check-in",
  text76:
    "Vous pouvez envoyer le lien ou créer un check-in manuel dans les options suivantes.",
  text77: "Check-in",
  text78: "Check-in manuel depuis le panneau d'administration.",
  text79: "Envoyer le check-in",
  text80: "Lien de réservation vers un client.",
  text81: "Chargement, veuillez patienter...",
  text82: "Ans",
  text83: "Jours",

  // Modal exportar
  text84: `EXPORTER`,
  text85: `Exporter les rapports dans WACheckin`,
  text86: `Télécharger le rapport de check-in`,
  text87: `Téléchargez les check-ins effectués par vos clients et obtenez un
    rapport détaillé avec des informations telles que la date de check-in, entre
    autres données.`,
  text88: `Télécharger le rapport migratoire`,
  text89: `Si la synchronisation automatique avec l'entité migratoire échoue,
    vous pouvez télécharger ce rapport et saisir manuellement les données de
    votre client.`,

  text90: `Clés remises`,
  text91: `Autorités`,
  text92: `Télécharger le rapport de police`,
  text93: `Supprimer le check-in`,
  text94: `Aucun client n'est encore enregistré dans votre hébergement`,
  text95: `Les clients enregistrés apparaîtront ici`,
  text96: `EXPORTER`,
  text97: `EXPORTER`,
  text98: `EXPORTER`,

  // Corrections

  p1: `Envoyer`,
  p2: `Lien de check-in`,
  p3: `Scanner`,
  p4: `Le client signera sur cet appareil`,
  p5: `Scanné`,
  p6: `Manuel`,
  p7: `Opérateur manuel`,
  p8: `check-ins`,
  p9: `Utilisez l'option de check-in manuel pour enregistrer vos clients directement depuis la réception`,
  p10: `Check-in manuel`,
  p11: `Envoyez le lien de check-in en ligne à vos clients par WhatsApp ou e-mail pour faciliter leur enregistrement avant leur arrivée`,
  p12: `Envoyer le check-in en ligne`,
  p13: `Non spécifié`,
  p14: `Supprimer le check-in`,
  p15: `Êtes-vous sûr de vouloir supprimer le check-in ? Vous ne pourrez pas récupérer les données supprimées`,
  p16: `Supprimer`,
  p17: `Annuler`,
  p18: `Débloquez tout le potentiel avec nos fonctionnalités premium`,
  p19: `Check-in automatique via WhatsApp`,
  p20: `Envoi des documents des voyageurs`,
  p21: `Vérification d'identité`,
  p22: `Évaluation automatique`,
  p23: `Vente croisée`,
  p24: `Gestion des clés des clients`,
  p25: `Facturation des clients`,
  p26: `Ne passez pas à côté des avantages !`,
  p27: `Passer à Premium`,

  p28: `Concept`,
  p29: `Frais supplémentaires`,
  p30: `Statut`,
  p31: `Payé`,
  p32: `En attente`,
  p33: `Remboursé`,
  p34: `Rembourser les frais`,
  p35: `Rembourser`,
  p36: `Êtes-vous sûr de vouloir rembourser les frais au client ?`,
  p37: `Document d'identité`,
  p38: `Passeport`,
  p39:`FILTRER`,
  p40:`Check-ins terminés`,
  p41:`Check-ins en cours`,
  p42: `Vous n'avez aucun check-in en cours`,
  p43: `Informations de check-in`,
  p44: `Check-ins associés`,
  p45: `Aucun check-in associé.`,
  p46: `Plus d'informations :`,
  p47: `Date de check-in :`,
  p48: `Date de check-out :`,

  p49:`Client`,
  p50:`Clients`,


};
